import './QuestionDetails.scss'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../../components/Header/Header'
import { QuestionsApi } from '../../services/api/questions'
import { QuestionResponse } from '../../types/types'
import { getApiErrorMessage } from '../../utils/api/getApiErrorMessage'
import { renderMarkdown } from '../../utils/markdown/renderMarkdown'

const getTagColorClass = (tagId: number) => 'question-details__tag_color_' + (tagId % 6)

export const QuestionDetailsPage = () => {
    const navigate = useNavigate()
    const { questionId } = useParams()
    const parsedQuestionId = useMemo(() => Number(questionId), [questionId])
    const [question, setQuestion] = useState<QuestionResponse | null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!questionId || Number.isNaN(parsedQuestionId)) {
            setError('Некорректный id вопроса')
            return
        }

        setIsLoading(true)
        setError(null)
        QuestionsApi.getQuestion(parsedQuestionId)
            .then(setQuestion)
            .catch((requestError) => setError(getApiErrorMessage(requestError, 'Ошибка загрузки вопроса')))
            .finally(() => setIsLoading(false))
    }, [parsedQuestionId, questionId])

    return (
        <>
            <Header />
            <main className="question-details">
                <section className="question-details__header">
                    <button className="question-details__back" type="button" onClick={() => navigate(-1)}>Назад</button>
                </section>

                {isLoading ? <p className="question-details__state">Загрузка...</p> : null}
                {error ? <p className="question-details__error">{error}</p> : null}

                {!isLoading && !error && question ? (
                    <article className="question-details__card">
                        <h1 className="question-details__title">{question.title}</h1>
                        <div className="question-details__tags">
                            {question.tags.map((tag) => (
                                <span key={tag.id} className={'question-details__tag ' + getTagColorClass(tag.id)}>{tag.name}</span>
                            ))}
                        </div>
                        <div className="question-details__answer">
                            {renderMarkdown(question.answer)}
                        </div>
                    </article>
                ) : null}
            </main>
        </>
    )
}
